import { render, staticRenderFns } from "./TeacherWorkRegime.vue?vue&type=template&id=b268c2a0"
import script from "./TeacherWorkRegime.vue?vue&type=script&lang=js"
export * from "./TeacherWorkRegime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports